import {
  IdentityApplicantsIdVerificationIdReportGetFormatEnum,
  IdentityApplicantsIdVerificationIdReportGetPresetEnum
} from 'src/lib/internal/epa/gen';

export {
  IdentityApplicantsIdVerificationIdReportGetFormatEnum as IdentityReportFormat,
  IdentityApplicantsIdVerificationIdReportGetPresetEnum as IdentityReportPreset
};

export enum fdeInboxTabs {
  DOCUMENTS = 0,
  IDENTIFICATION = 1,
  RENTAL_HISTORY = 2
}

export enum LinkAction {
  COPY = 0,
  NEW_TAB = 1
}
